import Vue from 'vue';
import Vuex from 'vuex';

import account from './account';
import accountBalance from './account-balance';
import application from './application';
import assetsDetail from './assets/detail';
import assetsList from './assets/list';
import assetsNew from './assets/new';
import blocks from './blocks';
import home from './home';
import keplr from './keplr';
import transactions from './transactions';
import validators from './validators';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    account,
    accountBalance,
    application,
    assetsDetail,
    assetsList,
    assetsNew,
    blocks,
    home,
    keplr,
    transactions,
    validators,
  },
});
